import { render, staticRenderFns } from "./term11.vue?vue&type=template&id=5dcf88b4"
import script from "./term11.vue?vue&type=script&lang=js"
export * from "./term11.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports